var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'code-widget-error': !_vm.data.value }},[_vm._t("default",null,{"value":_vm.escapedValue})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }